// This file is auto-generated by @hey-api/openapi-ts

/**
 * Defines the type of the customer account.
 */
export const CustomerAccountTypeEnum = { PERSONAL: 'PERSONAL', COMPANY: 'COMPANY' } as const;

/**
 * Defines the type of the customer account.
 */
export type CustomerAccountTypeEnum = typeof CustomerAccountTypeEnum[keyof typeof CustomerAccountTypeEnum];
